module.exports = __webpack_public_path__ + "static/media/aboutImg.b746d7b4.jpg";